__turbopack_context__.v({
  "card__wrapper": "pricing-module__NXQy5G__card__wrapper",
  "onboarding__btn": "pricing-module__NXQy5G__onboarding__btn",
  "subtext": "pricing-module__NXQy5G__subtext",
  "tabs": "pricing-module__NXQy5G__tabs",
});
